<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card :header="'Email Import For Package Wizard'">
          <el-form label-width="160px" :model="form" :rules="packageImport" ref="exportForm">
            <!-- Step 1 -->
            <div v-if="step == 1" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Introduction</h5>
                  <p>We allow you to import a csv file of names and email addresses to be easily distributed to a list of candidates.</p>

                  <p>&nbsp;</p>
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="12" class="text-right">
                      <el-button @click="next()">Next</el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>

            <!-- Step 2 -->
            <div v-if="step == 2" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Upload File</h5>
                  <p>Please upload your file using the button below.</p>
                  <el-upload
                    class="upload-demo"
                    name="importFile"
                    :action="basePath + 'packages/import/upload'"
                    :headers="getFileUploadHeaders"
                    :file-list="fileList"
                    :on-success="onSuccess"
                  >
                    <el-button size="small" type="primary">Click to upload</el-button>
                    <div slot="tip" class="el-upload__tip">csv files with a size less than 50MB</div>
                  </el-upload>
                </el-col>
              </el-row>
            </div>

            <!-- Step 3 -->
            <div v-if="step == 3" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <p>
                    <b>NOTE: Only showing the first 3 records of your file. The last page will show the final results of the import.</b> The purpose of only showing the first 3 records is so you can line up your records with our fields.
                  </p>
                  <p>Please use the form below to line up the columns:</p>
                  <el-checkbox v-model="skipTopRow" label="Top row is header information"></el-checkbox>
                </el-col>
              </el-row>
              <div class="table-responsive">
                <table class="table">
                  <tr>
                    <td v-for="(n, i) in sampledLines[0]" :key="i">
                      <select v-model="form.columnSort[i]">
                        <option v-for="c in columnSelection" :value="c.v" :key="c.$index">{{c.n}}</option>
                      </select>
                    </td>
                  </tr>
                  <tr v-for="n in sampledLines" :key="n.$index">
                    <td v-for="nn in n" :key="nn.$index">{{nn}}</td>
                  </tr>
                </table>
              </div>

              <p>&nbsp;</p>
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="12" class="text-right">
                      <el-button @click="next()">Next</el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>

            <!-- Step 4 -->
            <div v-if="step == 4" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>New / Existing Package</h5>
                  <p>Select the instrument the package will be based on.</p>

                  <el-row :gutter="20">
                    <el-col :span="12" :offset="6">
                      <el-radio v-model="mode" :label="1">New Package</el-radio>
                      <br />
                      <el-radio v-model="mode" :label="2">Existing Package</el-radio>
                    </el-col>
                  </el-row>

                  <div v-if="mode == 1">
                    <p>Choose a package name which will be easy for you to identify this package block later.</p>
                    <el-form-item label="Package Name:" prop="name">
                      <el-input v-model="form.name"></el-input>
                    </el-form-item>
                  </div>

                  <el-form-item v-if="mode == 1" label="Instrument:" prop="instrument">
                    <el-select v-model="instrument" placeholder="Select Instrument">
                      <el-option
                        v-for="item in form.instrumentOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <div v-if="mode == 2">
                    <p>Choose an existing package.</p>
                    <!-- getPackageList -->
                    <el-form-item label="Existing Package:" prop="Report">
                      <el-select v-model="form.existingPackage" placeholder="Select a Report">
                        <el-option
                          v-for="item in getPackageList"
                          :key="item.id"
                          :label="item.block_name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>

                  <div v-if="form.instrument">
                    <p>Select the default report to be emailed. Note, each of the following reports will be generated, however, on the one selected will be emailed.</p>
                    <el-form-item label="Default Report:" prop="Report">
                      <el-select v-model="form.report" placeholder="Select a Report">
                        <el-option
                          v-for="item in form.reports"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <p>&nbsp;</p>
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="12" class="text-right">
                      <el-button
                        v-if="mode === 1"
                        @click="next()"
                        :disabled="form.instrument === undefined || form.report === undefined"
                      >Next</el-button>
                      <!-- existingPackage -->
                      <el-button
                        v-if="mode === 2"
                        @click="next()"
                        :disabled="form.existingPackage === undefined"
                      >Next</el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
            <!-- Step 5 -->
            <div v-if="step == 5" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Email</h5>
                  <p>Adjust the email per your liking</p>
                  <p>
                    Available Tags:
                    <i>[CODE] [Link] [Company] [UserEmail] [ReportType] [FirstName] [LastName]</i>
                  </p>
                  <el-form-item label="Subject">
                    <el-input
                      :placeholder="'Please Enter a Subject Line'"
                      v-model="form.emailSubjectLine"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Message">
                    <el-input
                      v-model="form.emailMessage"
                      type="textarea"
                      :autosize="{ minRows: 10, maxRows: 25}"
                    ></el-input>
                  </el-form-item>

                  <p>&nbsp;</p>
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="12" class="text-right">
                      <el-button @click="next()">Next</el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
            <!-- Step 6 -->
            <div v-if="step == 6" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Review</h5>
                  <p>Please review the following.</p>
                </el-col>
              </el-row>
              <el-row v-if="mode === 1" :gutter="20">
                <el-col :span="6" :offset="6">
                  <p>Instrument:</p>
                </el-col>
                <el-col :span="12">
                  <p>{{form.instrumentNames[form.instrument]}}</p>
                </el-col>
              </el-row>
              <el-row v-if="mode === 1" :gutter="20">
                <el-col :span="6" :offset="6">
                  <p>Name:</p>
                </el-col>
                <el-col :span="12">
                  <p>{{form.name}}</p>
                </el-col>
              </el-row>
              <el-row v-if="mode === 2" :gutter="20">
                <el-col :span="6" :offset="6">
                  <p>Existing Package:</p>
                </el-col>
                <el-col :span="12">
                  <p>{{getExistingSelectedPackage}}</p>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6" :offset="6">
                  <p>Size:</p>
                </el-col>
                <el-col :span="12">
                  <p>{{storedFileName.numberLines}}</p>
                </el-col>
              </el-row>
              <el-row v-if="mode === 1" :gutter="20">
                <el-col :span="6" :offset="6">
                  <p>Report:</p>
                </el-col>
                <el-col :span="12">
                  <p>{{form.report}}</p>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <p>&nbsp;</p>
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="12" class="text-right">
                      <el-button
                        v-if="!importLoading"
                        @click.once="commitImport()"
                        type="primary"
                      >Import &amp; Email</el-button>
                      <div v-if="importLoading">Loading ...</div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
            <!-- Step 7 - Done -->
            <div v-if="step == 7" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Final Summary</h5>
                  <p v-if="mode === 1">
                    Package
                    <router-link :to="'/packages/v/' + finished.packageId">{{form.name}}</router-link>&nbsp;has been created.
                  </p>
                  <p v-if="mode === 2">
                    Package
                    <router-link
                      :to="'/packages/v/' + form.existingPackage"
                    >{{getExistingSelectedPackage}}</router-link>&nbsp;has been updated.
                  </p>
                </el-col>
              </el-row>
            </div>

            <div style="height:50px;"></div>

            <el-steps :active="step" align-center>
              <el-step title="Step 1" description="Introduction"></el-step>
              <el-step title="Step 2" description="File Upload"></el-step>
              <el-step title="Step 3" description="Column Selection"></el-step>
              <el-step title="Step 4" description="Package Type"></el-step>
              <el-step title="Step 5" description="Email"></el-step>
              <el-step title="Step 6" description="Review"></el-step>
              <el-step title="Step 7" description="Final Summary"></el-step>
            </el-steps>
          </el-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { unserialize } from '../../shared/unserialize.js';
import { basePath } from '../../shared/basePath';
import axios from '../../shared/axios';

export default {
  computed: {
    ...mapGetters('auth', ['getToken', 'getCompanyName']),
    ...mapGetters('packages', [
      'getPackageList',
      'getPackageUsers',
      'getUserIdsForCurrent',
      'getPackageUsersPage',
      'getPackageUsersPageSize',
      'getPackageNameById',
      'getPackageSettings'
    ]),
    getFileUploadHeaders() {
      const split = ' ';
      const headerKey = 'Bearer';
      return {
        authorization: headerKey + split + String(this.getToken)
      };
    },
    getExistingSelectedPackage() {
      const existing = this.form.existingPackage;
      for (const inc in this.getPackageList) {
        if (this.getPackageList[inc].id === existing) {
          return this.getPackageList[inc].block_name;
        }
      }
    }
  },
  watch: {
    step(n) {
      // console.log(n);
      if (n === 3) {
      }
    },
    instrument() {
      axios.get('/packages/new/reports/' + this.instrument).then(r => {
        const defaultLang = unserialize(r.data.reports[0].languages_supported);
        for (const inc in r.data.association) {
          this.form.reports.push({
            label: r.data.association[inc].report_name,
            value: r.data.association[inc].report_name
          });
        }
        this.form.instrument = this.instrument;
      });
    }
  },
  data() {
    return {
      settings: undefined,
      basePath: basePath(),
      step: 1,
      mode: undefined,
      skipTopRow: false,
      instrument: undefined,
      importLoading: false,
      form: {
        mode: undefined,
        columnSort: [],
        storedFileName: undefined,
        size: 0,
        instrument: undefined,
        name: '',
        instrumentOptions: [],
        instrumentNames: {},
        languageOptions: [],
        report: undefined,
        reports: [],
        sendEmail: false,
        emailSubjectLine: '',
        emailMessage: '',
        existingPackage: undefined
      },
      fileList: [],
      packageImport: {},
      sampledLines: [],
      storedFileName: undefined,
      totalImport: undefined,
      colomnSort: [],
      columnSelection: [
        { v: 'skip', n: '--Skip--' },
        { v: 'first_name', n: 'First Name' },
        { v: 'last_name', n: 'Last Name' },
        { v: 'e_mail_1', n: 'Email' }
      ],
      finished: { packageId: undefined }
    };
  },
  created() {
    axios.get('/settings/get').then(r => {
      this.settings = Object.assign({}, r.data.rawSettings);
      // console.log(this.settings);
      this.form.emailSubjectLine = this.settings.invite_subject_line;
      this.form.emailMessage = this.settings.invite_message;
    });
    axios
      .get('export/options')
      .then(r => {
        // console.log(r);
        const lang = [];
        const inst = [];

        // Languages
        for (const i in r.data.languages) {
          lang.push({
            value: r.data.languages[i].lang_abrv,
            label: r.data.languages[i].lang_fullname
          });
        }

        // Instruments
        const enabledTests = [];
        for (const ii in r.data.enabledTests) {
          enabledTests.push(r.data.enabledTests[ii].test_id);
        }
        for (const iii in r.data.tests) {
          if (enabledTests.indexOf(r.data.tests[iii].test_id) > -1) {
            inst.push({
              value: r.data.tests[iii].test_id,
              label: r.data.tests[iii].test_name_eng
            });
            const id = r.data.tests[iii].test_id;
            this.form.instrumentNames[id] = r.data.tests[iii].test_name_eng;
          }
        }

        this.form.languageOptions = lang;
        this.form.instrumentOptions = inst;
      })
      .catch(e => {
        console.log(e);
      });

    // Load Existing Packages
    const p = [];
    p.push(this.fetchTests());
    p.push(this.fetchPackageList());
  },
  methods: {
    ...mapActions('packages', ['fetchPackageList', 'fetchPackageSettings']),
    ...mapActions('tests', ['fetchTests']),
    onSuccess(res, file) {
      this.storedFileName = res;
      this.form.storedFileName = res.storedFiledName; // store the actual name
      this.sampledLines = res.headerLines;
      this.totalImport = res.numberLines;
      this.step = 3;
    },
    next() {
      this.step += 1;
    },
    prev() {
      this.step -= 1;
    },
    commitImport() {
      this.form.mode = this.mode;
      this.importLoading = true;
      axios
        .post('/packages/import/finalize', this.form)
        .then(r => {
          // console.log(r);
          this.step = 7;
          this.finished.packageId = r.data.packageId;
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
